import React from 'react';
import withStyles from '@mui/styles/withStyles';

const Separator = ({ classes, margin, ...props }) => {
    if (!isNaN(margin)) margin = `${margin}px 0 ${margin}px 0`;
    return (
        <div className={classes.root} style={{ margin }} {...props}>
            &nbsp;
        </div>
    );
};

const styles = ({ palette }) => ({
    root: {
        width: '100%',
        height: '1px',
        display: 'block',
        backgroundColor: palette.divider
    }
});

export default withStyles(styles)(Separator);
